import { render, staticRenderFns } from "./message-compact.vue?vue&type=template&id=025e8da8&"
import script from "./message-compact.vue?vue&type=script&lang=js&"
export * from "./message-compact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('025e8da8')) {
      api.createRecord('025e8da8', component.options)
    } else {
      api.reload('025e8da8', component.options)
    }
    module.hot.accept("./message-compact.vue?vue&type=template&id=025e8da8&", function () {
      api.rerender('025e8da8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/pm/message-compact.vue"
export default component.exports